// frontend/src/services/api.js
import axios from 'axios';

// Ortama göre URL belirle
// Localde çalışıyorsan: http://localhost:5000/api
// Sunucuda (Production) çalışıyorsan: /api (Domain'i otomatik alır)
const BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5000/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Her istekte Token kontrolü
api.interceptors.request.use(
  (config) => {
    const userInfo = localStorage.getItem('userInfo');
    
    // Hem 'userInfo' içindeki token'a hem de direkt 'token' anahtarına bak
    // (Bazen token ayrı kaydediliyor, garanti olsun)
    let token = localStorage.getItem('token');
    
    if (!token && userInfo) {
        try {
            const parsed = JSON.parse(userInfo);
            token = parsed.token;
        } catch (e) {
            console.error("Token parse hatası", e);
        }
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;